<div class="modal__fondo" (click)="cerrar.emit()">
  <!-- El clic no se propaga: el del fondo cierra, el del panel no. -->
  <div
    class="modal__panel"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="titulo() || null"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="modal__cerrar"
      (click)="cerrar.emit()"
      aria-label="Cerrar"
    >
      <svg app-icono nombre="close-icon"></svg>
    </button>

    @if (icono(); as glifo) {
      <div
        class="modal__icono"
        [style.background]="fondoIconoCss()"
        [style.color]="colorIconoCss()"
      >
        <svg app-icono [nombre]="glifo"></svg>
      </div>
    }

    @if (titulo(); as texto) {
      <h2 class="modal__titulo">{{ texto }}</h2>
    }

    @if (descripcion(); as texto) {
      <p class="modal__descripcion">{{ texto }}</p>
    }

    <ng-content />

    @if (etiquetaSecundaria(); as etiqueta) {
      <button
        type="button"
        class="modal__accion"
        (click)="accionSecundaria.emit()"
      >
        {{ etiqueta }}
      </button>
    }
  </div>
</div>
